import { Functions } from "../../Services/functions";

export class Packing {

  constructor(
    public order?: number,
    public supplierPid?: string,
    public depth?: number,
    public length?: number,
    public weight?: number,
    public width?: number,
    public internationalPid?: string,
    public contentQuantity?: number,
    public unit?: string,
    public unitDescription?: string,
    public quantityMin?: number,
    public quantityMax?: number,
    public guid: string = Functions.newGuid(),
    public quantityMinNumber?: number
  ) {

  }

  static getQuantityMin(packing: Packing): number {
    if (packing?.quantityMinNumber != null && Math.round(packing.quantityMinNumber) == packing.quantityMin) {
      return packing.quantityMinNumber;
    }
    return packing?.quantityMin;
  }

  static setQuantityMin(packing: Packing, quantity: number) {
    packing.quantityMinNumber = quantity;
    packing.quantityMin = quantity == null ? null : Math.round(quantity);
  }
}
